import replaceValue from './replaceValue';

const replaceValueMatching = (arr, test, newValue) => {
  const value = arr.find(test);

  return replaceValue(arr, value, newValue);
};

export default replaceValueMatching;